import React from "react";
import "./App.css";
import "./index.css";
import Weather from "./weather.js";
import "bootstrap/dist/css/bootstrap.css";

function App() {
  return (
    <div>
      {" "}
      <Weather defaultCity="Montreal" />;
    </div>
  );
}

export default App;
